import API_BASE_URL from './config';

// 存储 token
let authToken = localStorage.getItem('authToken');

// 设置 token
export const setAuthToken = (token) => {
  authToken = token;
  if (token) {
    localStorage.setItem('authToken', token);
  } else {
    localStorage.removeItem('authToken');
  }
};

// 获取 token
export const getAuthToken = () => authToken;

// 通用请求函数
const request = async (url, options = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  // ✅ 直接使用完整路径（包含 /api）
  const apiUrl = API_BASE_URL ? `${API_BASE_URL}${url}` : url;
  
  console.log('🔗 Request URL:', apiUrl);
  
  const response = await fetch(apiUrl, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ 
      message: `HTTP ${response.status}: ${response.statusText}` 
    }));
    throw new Error(error.message || '请求失败');
  }

  return response.json();
};

// 认证 API
export const authAPI = {
  login: (email, password) => 
    request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  register: (email, password) => 
    request('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  resetPassword: (email) => 
    request('/api/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  updateProfile: (displayName, photoURL) => 
    request('/api/auth/update-profile', {
      method: 'PUT',
      body: JSON.stringify({ displayName, photoURL }),
    }),
};

// 进度 API
export const progressAPI = {
  getProgress: (category) => 
    request(`/api/progress/${category}`),

  saveProgress: (category, progressData) => 
    request(`/api/progress/${category}`, {
      method: 'POST',
      body: JSON.stringify(progressData),
    }),

  getCumulativeMastered: (category) => 
    request(`/api/progress/cumulative/${category}`),

  getLeaderboard: () => 
    request('/api/progress/leaderboard/top'),

  releaseWord: (category, word) => 
    request(`/api/progress/${category}/word/${word}`, {
      method: 'DELETE',
    }),

  updateProfile: (displayName, photoURL) => 
    request('/api/progress/profile', {
      method: 'PUT',
      body: JSON.stringify({ displayName, photoURL }),
    }),
};

// 句子 API
export const sentencesAPI = {
  // 获取所有分类
  getSources: () =>
    request('/api/sentences/sources'),

  // 获取某分类的句子列表
  getBySource: (source) =>
    request(`/api/sentences/source/${encodeURIComponent(source)}`),

  // 获取学习进度
  getProgress: (source) =>
    request(`/api/sentences/progress/${encodeURIComponent(source)}`),

  // 削句（标记已掌握）
  masterSentence: (source, sentenceId) =>
    request(`/api/sentences/progress/${encodeURIComponent(source)}/master`, {
      method: 'POST',
      body: JSON.stringify({ sentenceId }),
    }),

  // 释放句子（取消掌握）
  releaseSentence: (source, sentenceId) =>
    request(`/api/sentences/progress/${encodeURIComponent(source)}/sentence/${sentenceId}`, {
      method: 'DELETE',
    }),

  // 搜索句子
  search: (keyword) =>
    request(`/api/sentences/search?q=${encodeURIComponent(keyword)}`),

  // 获取统计数据（个人中心用）
  getStats: () =>
    request('/api/sentences/stats'),

  // 重置某分类进度
  resetProgress: (source) =>
    request(`/api/sentences/progress/${encodeURIComponent(source)}`, {
      method: 'DELETE',
    }),
};